module.exports = __webpack_public_path__ + "static/media/chuquancf-04.daaae867.jpg";